import * as actions from "../../actions/actions";
import React from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import ColorPicker from "../nounproject-color-picker";
import ColorPalette from "./color-palette";
import { PresetPalette } from "./color-palette";
import { PaletteModes } from "../../reducers/editor";

class EditorColorSelection extends React.Component {
    colorSwatchSelected = color => {
        if (this.props.setColor) {
            this.props.setColor(color);
        }
    };

    render() {
        let colorSelectionUI, colorUI;

        if (this.props.paletteMode == PaletteModes.MODE_PICKER) {
            colorSelectionUI = (
                <ColorPicker
                    color={{
                        hex: this.props.color
                    }}
                    setColor={this.setColorPickerColor}
                    saturationStyles={{
                        width: 150,
                        height: 143
                    }}
                    hueStyles={{
                        width: 11,
                        height: 143,
                        marginRight: 3
                    }}
                />
            );
        } else {
            colorSelectionUI = (
                <PresetPalette setColor={this.colorSwatchSelected} />
            );
        }
        let palette;
        if (this.props.palette) {
            palette = (
                <ColorPalette
                    palette={this.props.palette}
                    setColor={this.colorSwatchSelected}
                />
            );
        }

        let paletteModes;
        if (this.props.editorSetPaletteMode) {
            let pickerClass = classnames("palette-mode-color-picker", {
                current: this.props.paletteMode == PaletteModes.MODE_PICKER
            });
            let swatchClass = classnames("palette-mode-color-swatches", {
                current: this.props.paletteMode == PaletteModes.MODE_PALETTE
            });
            paletteModes = (
                <ul className="editor-palette-modes pill-options">
                    <li
                        className={swatchClass}
                        onClick={this.props.editorSetPaletteMode.bind(
                            null,
                            PaletteModes.MODE_PALETTE
                        )}
                    >
                        palette
                    </li>
                    <li
                        className={pickerClass}
                        onClick={this.props.editorSetPaletteMode.bind(
                            null,
                            PaletteModes.MODE_PICKER
                        )}
                    >
                        custom color
                    </li>
                </ul>
            );
        }

        colorUI = (
            <div className="hero-color-picker editor-color-picker">
                {paletteModes}
                {colorSelectionUI}
                {palette ? (
                    <h3 className="palette-header">
                        <i className="ui_history" />color history
                    </h3>
                ) : null}
                {palette}
            </div>
        );

        return (
            <div className="plugin-select-box plugin-select-color">
                {colorUI}
            </div>
        );
    }

    setColorPickerColor = newCustomColor => {
        let {
            selectedColor: { hex }
        } = newCustomColor;

        if (this.props.setColor) {
            this.props.setColor(hex);
        }
    };
}

export default EditorColorSelection;
